<template>
  <b-form-group
    :horizontal="horizontal"
    :label-cols="labelCols ? labelCols : null"
    :invalid-feedback="firstErrorMessage"
    :state="isValid"
    :label="label">
    <slot
      :attrs="{ state: isValid }"
      :listeners="{ input: () => preferredValidator.$touch() }"/>
  </b-form-group>
</template>

<script>
import { singleErrorExtractorMixin } from 'vuelidate-error-extractor'

export default {
  name: 'FormElement',
  extends: singleErrorExtractorMixin,
  props: {
    horizontal: {
      type: Boolean,
      default: true,
    },
    inputCols: {
      type: Number,
      default: 4,
    },
  },
  computed: {
    labelCols() {
      return 12 - this.inputCols;
    },
  },
};
</script>
